'use client';

import type { HTMLAttributes, Ref } from 'react';
import { cn } from '@/lib/utils';

interface SeparatorProperties extends HTMLAttributes<HTMLDivElement> {
  decorative?: boolean;
  orientation?: 'horizontal' | 'vertical';
  ref?: Ref<HTMLDivElement>;
}

const Separator = ({
  className,
  orientation = 'horizontal',
  decorative = false,
  ref,
  ...properties
}: SeparatorProperties) => (
  <div
    ref={ref}
    className={cn(
      'shrink-0 bg-border/60',
      orientation === 'horizontal' ? 'h-[1px] w-full' : 'h-full w-[1px]',
      className
    )}
    aria-hidden={decorative ? 'true' : undefined}
    {...properties}
  />
);

export { Separator };
